var React = require('react');

function BrandbookInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6 6C6 3.79086 7.79086 2 10 2H38C40.2091 2 42 3.79086 42 6V42C42 44.2091 40.2091 46 38 46H10C7.79086 46 6 44.2091 6 42V6Z","stroke":"#FF6A3C","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M14 38H10C7.79086 38 6 39.7909 6 42V42C6 44.2091 7.79086 46 10 46H38C40.2091 46 42 44.2091 42 42V42C42 39.7909 40.2091 38 38 38H14ZM14 38V2","stroke":"#FF6A3C","strokeWidth":"3","key":1}),React.createElement("path",{"d":"M28 12L30.0206 18.2188H36.5595L31.2694 22.0623L33.2901 28.2812L28 24.4377L22.7099 28.2812L24.7306 22.0623L19.4405 18.2188H25.9794L28 12Z","fill":"#FF6A3C","key":2})]);
}

BrandbookInline.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = BrandbookInline;

BrandbookInline.default = BrandbookInline;
